import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import * as yup from "yup";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorContainer from "../../../Components/ErrorContainer";
import ModelContainer from "../../../Components/ModelContainer";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";
import MultiSelect from "../../../Components/MultiSelect.jsx";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import DateInput from "../../../Components/DateInput";
import { getFormData } from "../../../../helpers";

const HardwareMaster = (params) => {
  // const [showForm, setShowForm] = useState(false);
  const dispatch = useDispatch();
  const showForm = useSelector(
    (state) => state?.settingReducer.hardware_form_state
  );
  const setShowForm = (formState) =>
    dispatch(
      actions?.setFormState({ formName: "hardware_form_state", formState })
    );
  const hardwareMasterData = useSelector(
    (state) => state?.settingReducer?.hardware_master_data?.hardwareMaster
  );
  const editHardwareMasterData = useSelector(
    (state) => state?.settingReducer?.edit_hardware_master_data
  );
  const hardwareMasterFormData = useSelector(
    (state) => state?.settingReducer?.hardware_master_form_data
  );

  const [formType, setFormType] = useState("add");

  useEffect(() => {
    dispatch(actions.getHardwareMasterData());
    dispatch(actions.getHardwareMasterFormData());
  }, []);
  return (
    <UserInterface>
      <Headerbar />
      {!showForm && (
        <div className="no-sidebar row" id="content">
          <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
            <div className="container px-0">
              <div className="row mx-0">
                <div className="container px-0">
                  <div className="shadowclass">
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert"> Hardware List </h4>
                    </div>
                    <div className="row justify-content-between align-items-center">
                      <div className="col-md-4">
                        <div className="search-box mt-0">
                          <form type="GET">
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          setFormType("add");
                          setShowForm(true);
                        }}
                        class="text-right col-md-4 align-right"
                      >
                        <p class="btn green-btn-revert add-plus">
                          <i class="i-icon"> </i> Add Hardware
                        </p>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="checklist-table remove-space inventory_table">
                        {}
                        <tr>
                          <th class="header">ID</th>
                          <th class="header">Status</th>
                          <th width="" class="header">
                            Hardware Name
                          </th>
                          <th class="header">Hardware Type</th>
                          <th class="header">Maker</th>
                          <th class="header">Model</th>
                          <th class="header">Linked Station</th>
                          <th class="header">Actions</th>
                        </tr>
                        <tbody>
                          {hardwareMasterData?.map((el) => (
                            <>
                              <tr>
                                <td>{el.hardware_id}</td>
                                <td>{el.status}</td>
                                <td>{el.name}</td>
                                <td>{el.type}</td>
                                <td>{el.marker}</td>
                                <td>{el.model}</td>
                                <td>{el.linked_station_id}</td>
                                <td>
                                  {" "}
                                  <p
                                    onClick={() => {
                                      setFormType("edit");
                                      setShowForm(true);
                                      dispatch(
                                        actions.getEditHardwareMasterData(el.id)
                                      );
                                    }}
                                    className="circle_icon edit_tooltip"
                                  >
                                    <i class="iconSprites edit-icon"></i>{" "}
                                  </p>
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showForm && (
        <HardwareForm
          hardwareMasterFormData={hardwareMasterFormData}
          editHardwareMasterData={editHardwareMasterData}
          formType={formType}
          setFormType={setFormType}
          setShowForm={setShowForm}
        />
      )}
    </UserInterface>
  );
};
const HardwareForm = ({
  hardwareMasterFormData,
  editHardwareMasterData,
  formType,
  setShowForm,
}) => {
  const dispatch = useDispatch();
  const [linkedStation, setLinkedStation] = useState("");
  const [qualificationSelection, setQualificationSelection] = useState("");
  const [hardwareType, setHardwareType] = useState(null);
  const [qualificationLevelId, setQualificationLevelId] = useState(null);

  const hardwareFormEditDefaultState = {
    name: editHardwareMasterData?.name ?? "",
    type:
      editHardwareMasterData?.type == 1
        ? editHardwareMasterData?.type
        : editHardwareMasterData?.type ?? "",
    marker: editHardwareMasterData?.marker ?? "",
    model: editHardwareMasterData?.model ?? "",
    connection_type: editHardwareMasterData?.connection_type ?? "",
    target: editHardwareMasterData?.target ?? "",
    linked_station_id: editHardwareMasterData?.linked_station_id[0] ?? "",
    status: editHardwareMasterData?.status ?? "",
    qualification_level_id:
      editHardwareMasterData?.qualification_level_id ?? "",
    qualification_selection:
      editHardwareMasterData?.qualification_selection ?? "",
    kitchen_printer_name: editHardwareMasterData?.kitchen_printer_name ?? "",
    customer_receipt_name: editHardwareMasterData?.customer_receipt_name ?? "",
    apply_logo: editHardwareMasterData?.apply_logo ?? "",
    print_upon_hold: editHardwareMasterData?.print_upon_hold ?? "",
    customer_kitchen_ticket:
      editHardwareMasterData?.customer_kitchen_ticket ?? "",
    combine_same_bundled_items:
      editHardwareMasterData?.combine_same_bundled_items ?? "",
    print_duplicate_kitchen_ticket:
      editHardwareMasterData?.print_duplicate_kitchen_ticket ?? "",
    print_order_no_on_kitchen_ticket:
      editHardwareMasterData?.print_order_no_on_kitchen_ticket ?? "",
    print_table_transfer_alert:
      editHardwareMasterData?.print_table_transfer_alert ?? "",
    zero_value_items_receipts:
      editHardwareMasterData?.zero_value_items_receipts ?? "",
    show_content_on_receipt:
      editHardwareMasterData?.show_content_on_receipt ?? "",
    print_receipt_upon_successful_payment:
      editHardwareMasterData?.print_receipt_upon_successful_payment ?? "",
    port: editHardwareMasterData?.port ?? "",
    auto_amount_from_pos: editHardwareMasterData?.auto_amount_from_pos ?? "",
    menu_item_pricing_scale:
      editHardwareMasterData?.menu_item_pricing_scale ?? "",
  };
  const hardwareFormAddDefaultState = {
    name: "",
    type: "",
    marker: "",
    model: "",
    connection_type: "",
    target: "",
    linked_station_id: "",
    status: "",
    qualification_level_id: "",
    qualification_selection: "",
    kitchen_printer_name: "",
    customer_receipt_name: "",
    apply_logo: "",
    print_upon_hold: "",
    customer_kitchen_ticket: "",
    combine_same_bundled_items: "",
    print_duplicate_kitchen_ticket: "",
    print_order_no_on_kitchen_ticket: "",
    print_table_transfer_alert: "",
    zero_value_items_receipts: "",
    show_content_on_receipt: "",
    print_receipt_upon_successful_payment: "",
    port: "",
    auto_amount_from_pos: "",
    menu_item_pricing_scale: "",
  };
  const hardwareFormSchema = yup.object({
    name: yup.string().required(),
    type: yup.string().required(),
    marker: yup.string().required(),
    model: yup.string().required(),
    connection_type: yup.string().required(),
    target: yup.string().required(),
    linked_station_id:
      hardwareType === "1"
        ? yup.array().nullable().required()
        : yup.string().required(),
    status: yup.string().required(),
    qualification_level_id:
      hardwareType === "1" ? yup.string().required() : yup.string(),

    qualification_selection: ["1", "2"].includes(qualificationLevelId)
      ? yup.array().nullable().required()
      : yup.string(),

    kitchen_printer_name: ["1", "2"].includes(qualificationLevelId)
      ? yup.string().required()
      : yup.string(),

    customer_receipt_name:
      qualificationLevelId === "3" ? yup.string().required() : yup.string(),
    apply_logo:
      qualificationLevelId === "3" ? yup.string().required() : yup.string(),

    print_upon_hold: ["1", "2"].includes(qualificationLevelId)
      ? yup.string().required()
      : yup.string(),

    customer_kitchen_ticket:
      hardwareType === "1" ? yup.string().required() : yup.string(),
    combine_same_bundled_items:
      hardwareType === "1" ? yup.string().required() : yup.string(),
    print_duplicate_kitchen_ticket:
      hardwareType === "1" ? yup.string().required() : yup.string(),
    print_order_no_on_kitchen_ticket:
      hardwareType === "1" ? yup.string().required() : yup.string(),
    print_table_transfer_alert:
      hardwareType === "1" ? yup.string().required() : yup.string(),
    zero_value_items_receipts:
      qualificationLevelId === "3" ? yup.string().required() : yup.string(),
    show_content_on_receipt:
      qualificationLevelId === "3" ? yup.string().required() : yup.string(),
    print_receipt_upon_successful_payment:
      qualificationLevelId === "3" ? yup.string().required() : yup.string(),
    port: hardwareType === "2" ? yup.string().required() : yup.string(),
    auto_amount_from_pos:
      hardwareType === "2" ? yup.string().required() : yup.string(),
    menu_item_pricing_scale:
      hardwareType === "3" ? yup.string().required() : yup.string(),
  });
  const {
    register: hardwareFormRegister,
    formState: { errors: hardwareFormError },
    handleSubmit: hardwareFormSubmit,
    reset: hardwareFormReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(hardwareFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:
      formType === "add"
        ? hardwareFormAddDefaultState
        : hardwareFormEditDefaultState,
  });
  function Child({ control, formKey }) {
    const val = useWatch({
      control,
      name: formKey,
    });
    console.log(val, "lolololoo");
    return <p>Watch: {val}</p>;
  }
  const submitData = (data) => {
    const addSubmitData = {
      ...data,
      hardware_id: hardwareMasterFormData.hardware_id,
    };
    const editSubmitData = {
      ...data,
      hardware_id: editHardwareMasterData.hardware_id,
      id: editHardwareMasterData.id,
    };
    if (formType === "add")
      dispatch(actions.postHardwareMasterData(addSubmitData));
    else {
      dispatch(actions.postEditHardwareMasterData(editSubmitData));
    }
    setShowForm(false);
  };
  useEffect(() => {
    if (formType === "add") {
      setHardwareType(null);
      setQualificationLevelId(null);
      setQualificationSelection(null);
      hardwareFormReset(hardwareFormAddDefaultState);
      return;
    }
    setHardwareType(editHardwareMasterData?.type?.toString());
    setQualificationLevelId(
      editHardwareMasterData?.qualification_level_id?.toString()
    );
    setQualificationSelection(editHardwareMasterData?.qualification_selection);
    // {
    //   hardwareMasterFormData?.linked_station.filter((el) =>
    //     editHardwareMasterData?.linked_station_id.includes(el.value)
    //   );
    // }
    setLinkedStation(
      hardwareMasterFormData?.linked_station.filter((el) =>
        editHardwareMasterData?.linked_station_id.includes(el.value)
      )
    );
    dispatch(actions.setHardwareModel(editHardwareMasterData?.type));
    dispatch(actions.setHardwareMaker(editHardwareMasterData?.type));
    hardwareFormReset(hardwareFormEditDefaultState);
  }, [editHardwareMasterData, formType]);

  useEffect(() => {
    if ([1, 2].includes(editHardwareMasterData?.qualification_level_id))
      setQualificationSelection(
        hardwareMasterFormData?.qualification_selection_data?.filter((el) =>
          editHardwareMasterData?.qualification_selection.includes(el.value)
        )
      );
  }, [hardwareMasterFormData, formType]);

  return (
    <form onSubmit={hardwareFormSubmit(submitData)}>
      {console.log(hardwareFormError, "errrrror")}
      <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
        <div className="container px-0">
          <div className="row lbrSettingMs accountSettingSec d-flex">
            <div className="col-md-12 modify">
              <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
                <h4 class="event-alert d-flex aling-center pt-2 w-100 justify-content-between">
                  <span class="pull-left"> Hardware Details </span>
                  <div class="right-texts">
                    <span class="ingredient-status mx-3">0000011 </span>
                  </div>
                </h4>
                <p>
                  Please provide the configuration settings for this particular
                  piece of hardware. Depending on whether the hardware is a
                  printer or card terminal, complete the applicable fields.
                </p>
                <div className="d-flex calc-height w-100">
                  <div className="settings-left-content fixed-pos col-3">
                    <ul className="settingMenus">
                      <li id="AccDetail_li" className="active">
                        <a href="#_" id="AccDetail_dayTime_a">
                          HARDWARE <br /> INFO
                        </a>
                      </li>
                      {hardwareType === "1" && (
                        <li id="Address_li" className="">
                          <a href="#_" id="Address_dayTime_a">
                            PRINTER <br />
                            SETTINGS
                          </a>
                        </li>
                      )}
                      {hardwareType === "2" && (
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            CARD TERMINAL <br />
                            SETTINGS
                          </a>
                        </li>
                      )}
                      {hardwareType === "3" && (
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            SCANNER <br />
                            SETTINGS
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>

                  <div className="settings-right-content scrolling col-9">
                    <div className="date-sec-scroll">
                      <div
                        id="AccDetail_dayTime_div"
                        className="row-fluid scroll-change full_div"
                        day_time="AccDetail"
                      >
                        <div className="form-secs">
                          <h4> Hardware Info</h4>

                          <ul class="ingredient-info edit-shift">
                            <Input
                              label={"Hardware Name"}
                              formRegister={hardwareFormRegister}
                              formError={hardwareFormError}
                              formKey={"name"}
                            />

                            <Select
                              label={"Hardware Type"}
                              formRegister={hardwareFormRegister}
                              formError={hardwareFormError}
                              formKey={"type"}
                              optionsArray={
                                hardwareMasterFormData?.hardware_type
                              }
                              onChange={(e) => {
                                if (e.target.value === "") return;
                                setHardwareType(e.target.value);
                                dispatch(
                                  actions.setHardwareModel(e.target.value)
                                );
                                dispatch(
                                  actions.setHardwareMaker(e.target.value)
                                );
                              }}
                            />

                            <Select
                              label={"Model"}
                              formRegister={hardwareFormRegister}
                              formError={hardwareFormError}
                              formKey={"model"}
                              optionsArray={
                                hardwareMasterFormData?.hardware_model
                              }
                            />

                            <Select
                              label={"Connection Type"}
                              formRegister={hardwareFormRegister}
                              formError={hardwareFormError}
                              formKey={"connection_type"}
                              optionsArray={
                                hardwareMasterFormData?.hardware_connection_type
                              }
                            />
                            <Input
                              label={"Device Target"}
                              formRegister={hardwareFormRegister}
                              formError={hardwareFormError}
                              formKey={"target"}
                            />
                            {hardwareType === "1" ? (
                              <MultiSelect
                                label={" Linked Station"}
                                localStateValue={linkedStation}
                                setLocalStateMethod={setLinkedStation}
                                optionsArray={
                                  hardwareMasterFormData?.linked_station
                                }
                                formRegister={hardwareFormRegister}
                                formFieldSetMethod={setValue}
                                getFieldValues={getValues}
                                formKey={"linked_station_id"}
                                horizontal={true}
                              />
                            ) : (
                              <Select
                                label={"Linked Station"}
                                formRegister={hardwareFormRegister}
                                formError={hardwareFormError}
                                formKey={"linked_station_id"}
                                optionsArray={
                                  hardwareMasterFormData?.linked_station
                                }
                              />
                            )}

                            <Select
                              label={"Status"}
                              formRegister={hardwareFormRegister}
                              formError={hardwareFormError}
                              formKey={"status"}
                              optionsArray={hardwareMasterFormData?.status_id}
                            />
                          </ul>
                        </div>
                      </div>

                      {hardwareType === "1" && (
                        <div
                          id="Address_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="Address"
                        >
                          <div className="form-secs">
                            <h4> Printer Settings </h4>
                            <ul class="ingredient-info edit-shift">
                              <Select
                                label={"Maker"}
                                formRegister={hardwareFormRegister}
                                formError={hardwareFormError}
                                formKey={"marker"}
                                optionsArray={
                                  hardwareMasterFormData?.hardware_marker
                                }
                              />
                              {hardwareType === "1" && (
                                <Select
                                  label={"Qualification Level"}
                                  formRegister={hardwareFormRegister}
                                  formError={hardwareFormError}
                                  formKey={"qualification_level_id"}
                                  optionsArray={
                                    hardwareMasterFormData?.qualification_level
                                  }
                                  onChange={(e) => {
                                    if (e.target.value === "") return;
                                    setQualificationLevelId(e.target.value);
                                    if (e.target.value === "3")
                                      setValue("qualification_selection", "");
                                    dispatch(
                                      actions.getQualificationSelection(
                                        e.target.value
                                      )
                                    );
                                  }}
                                />
                              )}
                              {["1", "2"].includes(qualificationLevelId) && (
                                <>
                                  {/* multi dropdown */}
                                  <MultiSelect
                                    localStateValue={qualificationSelection}
                                    label={"Qualification Selection"}
                                    setLocalStateMethod={
                                      setQualificationSelection
                                    }
                                    optionsArray={
                                      hardwareMasterFormData?.qualification_selection_data
                                    }
                                    extraClass={"flex-wrap mb-2"}
                                    formRegister={hardwareFormRegister}
                                    formFieldSetMethod={setValue}
                                    getFieldValues={getValues}
                                    formKey={"qualification_selection"}
                                  />

                                  <ErrorContainer
                                    errors={hardwareFormError}
                                    name="qualification_selection"
                                  />
                                  <Select
                                    label={"Kitchen Print Name Used"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"kitchen_printer_name"}
                                    optionsArray={
                                      hardwareMasterFormData?.printer_name_used
                                    }
                                  />
                                </>
                              )}
                              {qualificationLevelId === "3" && (
                                <>
                                  <Select
                                    label={"Customer Receipt Name Used"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"customer_receipt_name"}
                                    optionsArray={
                                      hardwareMasterFormData?.printer_name_used
                                    }
                                  />

                                  <Select
                                    label={"Show Logo on Receipt?"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"apply_logo"}
                                    optionsArray={
                                      hardwareMasterFormData?.yes_no
                                    }
                                  />
                                </>
                              )}{" "}
                              {["1", "2"].includes(qualificationLevelId) && (
                                <Select
                                  label={"Print Upon Hold?"}
                                  formRegister={hardwareFormRegister}
                                  formError={hardwareFormError}
                                  formKey={"print_upon_hold"}
                                  optionsArray={hardwareMasterFormData?.yes_no}
                                />
                              )}
                              {hardwareType === "1" && (
                                <>
                                  <Select
                                    label={"Customer Kitchen Ticket"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"customer_kitchen_ticket"}
                                    optionsArray={
                                      hardwareMasterFormData?.customer_kitchen_ticket
                                    }
                                  />
                                  <Select
                                    label={"Combine Same Bundled Menu Items"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"combine_same_bundled_items"}
                                    optionsArray={
                                      hardwareMasterFormData?.yes_no
                                    }
                                  />
                                  <>
                                    <Select
                                      label={"Print Duplicate Kitchen Ticket"}
                                      formRegister={hardwareFormRegister}
                                      formError={hardwareFormError}
                                      formKey={"print_duplicate_kitchen_ticket"}
                                      optionsArray={
                                        hardwareMasterFormData?.yes_no
                                      }
                                    />
                                    <Select
                                      label={
                                        "Print Order Number on Kitchen Ticket"
                                      }
                                      formRegister={hardwareFormRegister}
                                      formError={hardwareFormError}
                                      formKey={
                                        "print_order_no_on_kitchen_ticket"
                                      }
                                      optionsArray={
                                        hardwareMasterFormData?.yes_no
                                      }
                                    />
                                    <Select
                                      label={"Print Table Transfer Alert"}
                                      formRegister={hardwareFormRegister}
                                      formError={hardwareFormError}
                                      formKey={"print_table_transfer_alert"}
                                      optionsArray={
                                        hardwareMasterFormData?.yes_no
                                      }
                                    />
                                  </>
                                </>
                              )}
                              {qualificationLevelId === "3" && (
                                <>
                                  <Select
                                    label={"Show Zero Value Items on Receipts?"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"zero_value_items_receipts"}
                                    optionsArray={
                                      hardwareMasterFormData?.zero_value_items_receipts
                                    }
                                  />
                                  <Select
                                    label={"Show Content on Receipt"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"show_content_on_receipt"}
                                    optionsArray={
                                      hardwareMasterFormData?.yes_no
                                    }
                                  />
                                  <Select
                                    label={
                                      "Print receipt upon successful payment"
                                    }
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={
                                      "print_receipt_upon_successful_payment"
                                    }
                                    optionsArray={
                                      hardwareMasterFormData?.print_receipt_upon_successful_payment
                                    }
                                  />
                                </>
                              )}
                            </ul>
                          </div>
                        </div>
                      )}

                      {hardwareType === "2" && (
                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4>
                              Card Terminal <br /> Settings
                            </h4>
                            <ul class="ingredient-info edit-shift d-flex">
                              <Select
                                label={"Maker"}
                                formRegister={hardwareFormRegister}
                                formError={hardwareFormError}
                                formKey={"marker"}
                                optionsArray={
                                  hardwareMasterFormData?.hardware_marker
                                }
                              />
                              {hardwareType === "2" && (
                                <>
                                  <Input
                                    label={"Port"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"port"}
                                  />

                                  <Select
                                    label={"Auto-Amount From POS?"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"auto_amount_from_pos"}
                                    optionsArray={
                                      hardwareMasterFormData?.yes_no
                                    }
                                  />
                                </>
                              )}
                            </ul>
                          </div>
                        </div>
                      )}
                      {hardwareType === "3" && (
                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4>
                              Scanner <br /> Settings
                            </h4>
                            <ul class="ingredient-info edit-shift">
                              {hardwareType === "3" && (
                                <>
                                  <Select
                                    label={"Maker"}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"marker"}
                                    optionsArray={
                                      hardwareMasterFormData?.hardware_marker
                                    }
                                  />
                                  <Select
                                    label={"Menu Item Pricing Scale "}
                                    formRegister={hardwareFormRegister}
                                    formError={hardwareFormError}
                                    formKey={"menu_item_pricing_scale"}
                                    optionsArray={
                                      hardwareMasterFormData?.menu_item_pricing_scale
                                    }
                                  />
                                </>
                              )}
                            </ul>
                          </div>
                        </div>
                      )}
                      {hardwareType === "1" && (
                        <PrinterTable hardwareType={hardwareType} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-0">
            <div class="container px-0 d-flex col-12">
              <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                <button
                  onClick={() => setShowForm(false)}
                  id="cancel"
                  type="button"
                >
                  Cancel
                </button>
                <button id="" type="Submit">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

const PrinterTable = ({ hardwareType }) => {
  // const [addReceiptModal, setAddReceiptModal] = useState(false);
  const dispatch = useDispatch();

  const addReceiptModal = useSelector(
    (state) => state?.settingReducer.hardware_modal_state
  );
  const setAddReceiptModal = (modalState) =>
    dispatch(
      actions?.setModalState({ modalName: "hardware_modal_state", modalState })
    );

  const hardwareDetailsSessionData = useSelector(
    (state) => state?.settingReducer?.hardware_details_session_data
  );
  useEffect(() => {
    dispatch(actions.getHardwareDetailsSession());
  }, []);
  return (
    <li class="auto-hgt">
      <div className="table-responsive">
        <table
          id="payroll_frequency"
          class="checklist-table remove-space aviTable"
          cellspacing="0"
          cellpadding="0"
          width="100%"
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Status</th>
              <th>Promotion Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Upload</th>
              <th>Last Updated</th>
            </tr>
          </thead>
          <tbody id="AddPayrollFrequencies">
            {hardwareDetailsSessionData?.details?.map((el) => (
              <tr>
                <td>{el?.id}</td>
                <td>{el?.status}</td>
                <td>{el?.promotion_name}</td>
                <td>{el?.start_date}</td>
                <td>{el?.end_date}</td>
                <td>{el?.upload_url}</td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        onClick={() => {
          setAddReceiptModal(true);
        }}
        class="my-3"
      >
        <p class="btn green-btn-revert add-plus" _>
          <i class="i-icon"> </i> Add Content
        </p>
      </div>
      <AddReceiptModal
        addReceiptModal={addReceiptModal}
        setAddReceiptModal={setAddReceiptModal}
        hardwareType={hardwareType}
        hardwareDetailsSessionData={hardwareDetailsSessionData}
      />
    </li>
  );
};

const AddReceiptModal = ({
  addReceiptModal,
  setAddReceiptModal,
  hardwareType,
  hardwareDetailsSessionData,
}) => {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const addReceiptFormlDefaultState = {
    status: "",
    promotion_name: "",
    hardware_type: "",
    start_date: "",
    end_date: "",
    upload_url: "",
  };
  const addReceiptModalSchema = yup.object().shape({
    status: yup.string().required(),
    promotion_name: yup.string().required(),
    start_date: yup.string().required(),
    end_date: yup.string().required(),
    upload_url: yup.mixed().required(),
  });
  const submitData = (data) => {
    console.log(data, "dataaaaaA", data.upload_url[0]);
    const submitData = getFormData({
      ...data,
      hardware_type: hardwareType,
      upload_url: data.upload_url[0],
    });
    console.log(submitData);
    dispatch(actions?.postHardwareDetailsSession(submitData));
  };
  const {
    register: addReceiptModalRegister,
    formState: { errors: addReceiptModalError },
    handleSubmit: addReceiptFormSubmit,
    reset: addReceiptFormReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(addReceiptModalSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: addReceiptFormlDefaultState,
  });

  return (
    <ModelContainer
      title="Add Receipt Content"
      open={addReceiptModal}
      closeModal={() => setAddReceiptModal(!AddReceiptModal)}
      submitModal={addReceiptFormSubmit(submitData)}
    >
      <form>
        <div className="form-list">
          <ul className="px-0">
            {/*edit account 1 */}
            {console.log(addReceiptModalError, "addReceiptModalError")}
            <Select
              label={"Status"}
              formRegister={addReceiptModalRegister}
              formError={addReceiptModalError}
              formKey="status"
              optionsArray={hardwareDetailsSessionData?.status}
              isModal
            />
            <Input
              label={"Promotion Name"}
              formRegister={addReceiptModalRegister}
              formError={addReceiptModalError}
              formKey="promotion_name"
              isModal
            />

            <DateInput
              label={"Start Date"}
              formRegister={addReceiptModalRegister}
              formError={addReceiptModalError}
              formKey="start_date"
              isModal
              dateVal={startDate}
              setDateVal={setStartDate}
              setFormField={setValue}
            />
            <DateInput
              label={"End Date"}
              formRegister={addReceiptModalRegister}
              formError={addReceiptModalError}
              formKey="end_date"
              isModal
              dateVal={endDate}
              setDateVal={setEndDate}
              setFormField={setValue}
            />
            <Input
              label={"Upload"}
              formRegister={addReceiptModalRegister}
              formError={addReceiptModalError}
              formKey="upload_url"
              isModal
              type="file"
            />
            {/* <li>
              <label> Upload</label>
              <input
                type="file"
                {...addReceiptModalRegister("upload_url")}
                className="input-wrap select-div"
              />
            </li> */}
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};
export default HardwareMaster;
